import { Outlet } from 'react-router-dom';
import { FarmContextProvider } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/FarmContextProvider';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { ErrorPage } from '../ErrorPage';

export function FarmSettingsRoot() {
    return (
        <SuspenseWrapper ErrorComponent={ErrorPage}>
            <FarmContextProvider>
                <Outlet />
            </FarmContextProvider>
        </SuspenseWrapper>
    );
}
